import { render } from "./ChatButton.vue?vue&type=template&id=cc3eb876&scoped=true"
import script from "./ChatButton.vue?vue&type=script&lang=js"
export * from "./ChatButton.vue?vue&type=script&lang=js"

import "./ChatButton.vue?vue&type=style&index=0&id=cc3eb876&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3eb876"]])

export default __exports__